import { render, staticRenderFns } from "./RateDialog.vue?vue&type=template&id=f1feb57e&scoped=true&lang=html&"
import script from "./RateDialog.vue?vue&type=script&lang=js&"
export * from "./RateDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1feb57e",
  null
  
)

export default component.exports